import React, { useState } from "react";
import SignInTemplate from "../../../layout/sign-in-template/SignInTemplate";
import Image from "../../../common/image/Image";
import MarketLogo from "../../../../assets/images/Onetransfer-logo-wbg.png";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import {
	AntdButton,
	AntdModal,
	Body,
	Footer,
	Header,
	HeaderDesc,
	HeaderTitle,
	LinkList,
	LogoWrap,
	Main,
	Page,
	Section,
	Space,
	TermsCard,
	TermsIntro,
	Text,
	TrustDot,
	TrustItem,
	TrustRow,
} from "./styles";
import { useAuth } from "../../../../contexts/authContext";
import { send_in_progress_validation_email } from "../../../../api/endpoints/auth";
import TermsModal from "./components/terms-modal/TermsModal";
import TermsPolicy from "./components/policy-modal/TermsPolicy";
import { Typo } from "../../../layout/theme";
import {
	ClockCircleOutlined,
	LockOutlined,
	SafetyOutlined,
} from "@ant-design/icons";

export default function TermsOfService({ user }) {
	const [submitting, setSubmitting] = useState(false);
	const { updateTermsOfService } = useAuth();
	const [showTermsModal, setShowTermsModal] = useState(false);
	const [showPolicyModal, setShowPolicyModal] = useState(false);

	const termOfService = async () => {
		try {
			function setsubm() {
				setSubmitting(true);
			}
			setTimeout(setsubm, 500);

			function tos() {
				updateTermsOfService();
				openNotificationWithIcon(
					TYPE.SUCCESS,
					"Términos de servicios aceptados con éxito",
				);
			}
			setTimeout(tos, 4000);

			if (!user.validated) {
				await send_in_progress_validation_email(user.email);
			}
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"No se pudo completar la operación",
				"Debe aceptar los términos de servicio para unirse a One Transfer",
			);
		} finally {
			setSubmitting(false);
		}
	};

	const handleTermsClick = () => setShowTermsModal(true);
	const handleTermsOk = () => setShowTermsModal(false);
	const handleTermsCancel = () => setShowTermsModal(false);

	const handlePolicyClick = () => setShowPolicyModal(true);
	const handlePolicyOk = () => setShowPolicyModal(false);
	const handlePolicyCancel = () => setShowPolicyModal(false);

	return (
		<SignInTemplate columns="1">
			<Page>
				<Main>
					<LogoWrap>
						<Image
							src={MarketLogo}
							alt="Logo One Transfer"
							height="45px"
							width="220px"
						/>
					</LogoWrap>

					<Header>
						<HeaderTitle>Términos de servicio</HeaderTitle>
						<HeaderDesc>
							Debe aceptar los términos y políticas para completar su acceso a
							One Transfer
						</HeaderDesc>
					</Header>

					<Body>
						<Section>
							<TermsCard>
								<TermsIntro>
									Antes de continuar, le recomendamos revisar los documentos
									legales relacionados con el uso de la plataforma, privacidad y
									cookies.
								</TermsIntro>

								<LinkList>
									<Text type="button" onClick={handleTermsClick}>
										Términos y condiciones
									</Text>

									<Text type="button" onClick={handlePolicyClick}>
										Políticas de privacidad y Cookies
									</Text>
								</LinkList>

								<Space />

								<AntdButton
									type="primary"
									onClick={termOfService}
									loading={submitting}
								>
									<Typo type="white" level={6}>
										Aceptar todo y acceder a One Transfer
									</Typo>
								</AntdButton>
							</TermsCard>

							<AntdModal
								title="Términos y condiciones"
								open={showTermsModal}
								onOk={handleTermsOk}
								onCancel={handleTermsCancel}
								width={1200}
								centered={true}
								footer={null}
								destroyOnClose={true}
							>
								<TermsModal user={user} />
							</AntdModal>

							<AntdModal
								title="Políticas de privacidad y Cookies"
								open={showPolicyModal}
								onOk={handlePolicyOk}
								onCancel={handlePolicyCancel}
								width={1200}
								centered={true}
								footer={null}
								destroyOnClose={true}
							>
								<TermsPolicy user={user} />
							</AntdModal>

							<Footer>
								Al continuar, confirma que leyó y acepta los documentos legales
								aplicables.
							</Footer>

							<TrustRow>
								<TrustItem>
									<SafetyOutlined />
									Conexión segura
								</TrustItem>

								<TrustDot />

								<TrustItem>
									<LockOutlined />
									Datos encriptados
								</TrustItem>

								<TrustDot />

								<TrustItem>
									<ClockCircleOutlined />
									Disponible 24/7
								</TrustItem>
							</TrustRow>
						</Section>
					</Body>
				</Main>
			</Page>
		</SignInTemplate>
	);
}
